import { render, staticRenderFns } from "./SideDrawerTour.vue?vue&type=template&id=0f40a890"
import script from "./SideDrawerTour.vue?vue&type=script&lang=js"
export * from "./SideDrawerTour.vue?vue&type=script&lang=js"
import style0 from "./SideDrawerTour.vue?vue&type=style&index=0&id=0f40a890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports